/// <amd-module name="Test/ManageTestPlans/LicenseUtils" />
import { ITestManagementPermissions } from "Test/ManageTestPlansCommon/Contracts";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";


export function isAdvancedTestExtensionEnabled(pageContext: IVssPageContext): boolean {
    let contributionService: IVssContributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    let permissions = contributionService.getData<ITestManagementPermissions>("ms.vss-test-web.testPlan-hub-advanced-test-extension-permissions-data-provider");
    if (permissions) {
        return permissions.isAdvancedTestExtensionEnabled;
    }
    else {
        return false;
    }
}

